export const Roles = {
  SUPER_ADMIN: "superadmin",
  COMPANY_ADMIN: "companyadmin",
  COMPANY_MANAGER: "companymanager",
  AGENT: "agent",
};
